export const privatePolicy = `
Politique de confidentialité
Charte de Kinship Edu
‍
1. Conseils : bonnes pratiques
Depuis la mise en place du Règlement Général sur la Protection des Données (RGPD) le 25mai 2018, vous êtes responsable des données personnelles que vous traitez en utilisant les applications numériques de Kinship. En tant que sous-traitant, nous prenons toutes les mesures pour nous mettre en conformité avec le RGPD et assurer une protection maximale des données que vous nous demandez de traiter. Vous trouverez ci-après quelques conseils pour vérifier si vos usages quotidiens permettent de garantir la sécurité des données scolaires de vos élèves.

1.1. Adoptez une politique de mot de passe rigoureuse
C’est la première des protections ! Un mot de passe solide, propre à l’utilisation du réseau Kinship est indispensable. Nous vous conseillons donc :
● de choisir un mot de passe d’au moins 8 caractères contenant des minuscules, des majuscules et des caractères spéciaux ;
● de changer régulièrement ce mot de passe ;
● de ne pas l’enregistrer sur votre navigateur Internet car il y serait alors lisible en clair.

1.2. Mettre à jour votre environnement informatique
C’est la première des protections ! Un mot de passe solide, propre à l’utilisation du réseau Kinship est indispensable. Nous vous conseillons donc :
● de choisir un mot de passe d’au moins 8 caractères contenant des minuscules, des majuscules et des caractères spéciaux ;
● de changer régulièrement ce mot de passe ;
● de ne pas l’enregistrer sur votre navigateur Internet car il y serait alors lisible en clair.

1.3. Gérer les accès à vos ordinateurs/tablettes/téléphones
C’est la première des protections ! Un mot de passe solide, propre à l’utilisation du réseau Kinship est indispensable. Nous vous conseillons donc :
● de choisir un mot de passe d’au moins 8 caractères contenant des minuscules, des majuscules et des caractères spéciaux ;
● de changer régulièrement ce mot de passe ;
● de ne pas l’enregistrer sur votre navigateur Internet car il y serait alors lisible en clair.


2. Charte de protection des données
Ayant été enseignants, nous mesurons l'importance des données qui nous sont confiées : le respect de ces données est notre priorité et, à travers cette charte de bonne conduite et de confiance, nous nous engageons à les protéger.

2.1. Transparence
Nous nous engageons à vous donner toutes les informations pour comprendre où, comment et par qui sont traitées vos données ou celles de vos élèves ou de vos enfants. Nous vous informerons également d'une éventuelle violation de vos données.

2.2. Serveurs en France
Nous nous engageons à héberger vos données en France selon de stricts protocoles de sécurité, avec des sous-traitants sérieux et professionnels.

2.3. Finalités claires
Nous nous engageons à traiter vos données personnelles uniquement dans le but d'exécuter les services annoncés : elles ne seront jamais utilisées à des fins commerciales, vendues, échangées ou transférées à des tiers (sauf sur demande des autorités judiciaires).

2.4. Déontologie
Nous nous engageons à offrir le meilleur conseil possible sans jamais émettre de jugement sur les données professionnelles ou scolaires que nous pourrions consulter en apportant une assistance technique.

2.5. Accès, modification
Nous nous engageons à faciliter la consultation, modfication ou suppression de vos données à tout moment et après accord du responsable des traitements le cas échéant, sur l'interface web ou auprès du support.

2.6. Droit à l'oubli
Nous nous engageons à effacer définitivement toute trace de donnée supprimée au bout d'un an* ou sans délai en cas de demande expresse et après accord du responsable des traitements le cas échéant.

Quelle sécurité pour vos données ?

1. Infrastructure
● Bases de données stockées sur un serveur sécurisée
● Composants logiciels mis à jour
● Acc.s admin par mot de passe et lien https
● Journalisation et monitoring
● Pare-feu et protection DDOS

2. Applications
● Connexion chiffrée de bout en bout avec TLS
● Mots de passe hashés à sens unique
● Filtre des entrées contre XSS et injections SQL
● Usage de tokens contre les attaques XSRF

3. Procédures
● Une sauvegarde par jour
● Tests réguliers des plans d'urgence
● Principe de moindre privilège
● Support technique sensibilisé à la sécurité
● Prestataires offrant les meilleures garanties

Le RGPD à l'école
‍
Comme toutes les administrations et entreprises qui manipulent des données personnelles,les écoles doivent se conformer au RGPD.

1. Qui est responsable ?
Le chef d'établissement est responsable des données traitées. Pour les écoles privées, c'estdonc le directeur ou la directrice qui assume ce rôle.

Un directeur du public n'est pas considéré comme responsable de traitement au sens del’article 3 de la loi du 6 janvier 1978. La responsabilité des traitements de données est doncendossée par le Directeur Académique des Services de l’Education Nationale (DASEN).

2. Consentement
Les écoles exécutent une mission d'intérêt public et ont l’obligation de permettre l'exercice des droits relatifs aux données personnelles. Nous vous conseillons donc de présenter les applications que vous pensez utiliser en réunion de rentrée chaque début d’année, et de fournir un document-type à chaque famille pour les informer.

3. Tenue des registres
Les responsables de traitement doivent tenir à jour un registre consignant l'ensemble des traitements réalisés, leurs finalités, les moyens mis en oeuvre, les sous-traitants, etc. Des analyses d'impact visant à évaluer les conséquences en cas de violation de données doivent également être réalisées.

4. Choix des prestataires
Pour mener à bien leurs missions, les enseignants utilisent parfois des outils tels que le réseau Kinship. Le responsable de traitement doit s'assurer de leur conformité au RGPD.
`